<template>
  <f7-page :page-content="true">
    <f7-navbar :back-link="$t('atras')">
      <f7-nav-title v-if="id && !readonly" sliding>{{$t('clientes.cliente_form.editar_cliente')}}</f7-nav-title>
      <f7-nav-title v-else-if="id" sliding>{{$t('clientes.cliente_form.cliente')}}</f7-nav-title>
      <f7-nav-title v-else sliding>{{$t('clientes.cliente_form.nuevo_cliente')}}</f7-nav-title>
      <f7-nav-right>
        <f7-button
          v-if="!readonly"
          fill
          icon-f7="floppy_disk"
          text="Guardar"
          class="display-flex"
          @click="$refs.rform.saveItem()"
        ></f7-button>
      </f7-nav-right>
    </f7-navbar>
    <r-form
      ref="rform"
      v-slot="{rform}"
      :itemId="id"
      @save="onSave"
      @loadItem="loadItem"
      :readonly="readonly"
      :dbAdapter="Cliente"
      :defaultData="{firmas: {firmasDisponibles:[]}}"
      :beforeSave="beforeSave"
      :documentoAdapter="Documento"
    >
      <f7-card v-noroles="['RESPONSABLE','ADMINISTRATIVO']" class="padding-vertical-half padding-right" style="z-index: 3000">
        <f7-card-content>
          <f7-row no-gap class="list list-form no-hairlines">
            <f7-col width="100" medium="20">
              <r-files 
                class="col-33" 
                :maxFiles="1"
                :label="$t('clientes.cliente_form.imagen')" 
                :form="rform" 
                :name="'imagen'" 
                :documentoAdapter="Documento"
              />
              <r-input
                floating-label
                :label="$t('clientes.cliente_form.conectarConSIMECAR')"
                :form="rform"
                type="check"
                name="conectarConSIMECAR"
              ></r-input>
              <div v-if="rform.formData.conectarConSIMECAR">
                <!-- private String urlServer; -->
                <r-input floating-label :label="$t('clientes.cliente_form.servidor.urlServer')" :form="rform" type="text" name="servidor.url" :clear-button="false"></r-input>
                <!-- private String tokenServer; -->
                <r-input
                  floating-label
                  :label="$t('clientes.cliente_form.servidor.tokenServer')"
                  :form="rform"
                  type="text"
                  name="servidor.token"
                >pepe</r-input>
              </div>
            </f7-col>
            <f7-col width="100" medium="40">
              <ul>
                <f7-row>
                  <r-input
                    class="col-50"
                    floating-label
                    :label="$t('clientes.cliente_form.cif')"
                    :form="rform"
                    type="text"
                    name="cif"
                  ></r-input>
                  <r-input
                    class="col-50"
                    floating-label
                    :label="$t('clientes.cliente_form.nombre')"
                    :form="rform"
                    type="text"
                    name="nombre"
                  ></r-input>
                </f7-row>
                <r-input
                  floating-label
                  :label="$t('clientes.cliente_form.eMail')"
                  :form="rform"
                  type="text"
                  name="email"
                ></r-input>
                <r-input
                  floating-label
                  :label="$t('clientes.cliente_form.razonSocial')"
                  :form="rform"
                  type="text"
                  name="razonSocial"
                ></r-input>
                  <!-- :readonly="id != undefined" -->
                <r-input
                  v-roles="['ADMIN']" 
                  floating-label
                  :label="$t('clientes.cliente_form.tipoCliente')"
                  :form="rform"
                  type="select"
                  name="tipoCliente"
                  @change="changeTipoCliente"
                >
                  <option selected disabled></option>
                  <option value="MARCA">Marca</option>
                  <option value="GRUPO_AUTOMOCION">Grupo de automoción</option>
                  <option value="CONCESIONARIO">Concesionario</option>
                </r-input>
                <r-input
                  v-roles="['ADMINISTRATIVO']"
                  v-if="!$refs.rform || !$refs.rform.formData || !$refs.rform.formData.tipoCliente || $refs.rform.formData.tipoCliente != 'MARCA'"
                  floating-label
                  :label="$t('clientes.cliente_form.tipoCliente')"
                  :form="rform"
                  type="select"
                  name="tipoCliente"
                  @change="changeTipoCliente"
                >
                  <option selected disabled></option>
                  <!-- <option value="MARCA">Marca</option> -->
                  <option value="GRUPO_AUTOMOCION">Grupo de automoción</option>
                  <option value="CONCESIONARIO">Concesionario</option>
                </r-input>
                <r-input
                  v-roles="['ADMINISTRATIVO']"
                  v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.tipoCliente && $refs.rform.formData.tipoCliente == 'MARCA'"
                  floating-label
                  :label="$t('clientes.cliente_form.tipoCliente')"
                  :form="rform"
                  type="select"
                  name="tipoCliente"
                  @change="changeTipoCliente"
                  :readonly="true"
                  :overrideReadonly="true"
                >
                  <option selected disabled></option>
                  <option value="MARCA">Marca</option>
                  <option value="GRUPO_AUTOMOCION">Grupo de automoción</option>
                  <option value="CONCESIONARIO">Concesionario</option>
                </r-input>
                <r-autocomplete
                  v-if="!$refs.rform || !$refs.rform.formData || !$refs.rform.formData.tipoCliente || $refs.rform.formData.tipoCliente != 'MARCA'"
                  :dbAdapter="Cliente"
                  floating-label
                  :label="$t('clientes.cliente_form.clientePadre')"
                  :form="rform"
                  name="idPadre"
                  nameId="idPadre"
                  idProp="id"
                  labelProp="nombre"
                  @change="changePadre"
                ></r-autocomplete>
                <f7-row>
                  <r-input
                    floating-label
                    :label="$t('clientes.cliente_form.hora_apertura')"
                    :form="rform"
                    type="datepicker"
                    name="horaApertura"
                    ref="horaApertura"
                    hidden
                    :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit'} }"
                  ></r-input>
                  <r-timepicker
                    floating-label
                    :label="$t('clientes.cliente_form.hora_apertura')"
                    :form="rform"
                    :readonly="false"
                    class="col-50"
                    name="horaApertura"
                  ></r-timepicker>
                  <r-input
                    floating-label
                    :label="$t('clientes.cliente_form.hora_cierre')"
                    :form="rform"
                    type="datepicker"
                    name="horaCierre"
                    ref="horaCierre"
                    hidden
                    :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit'} }"
                  ></r-input>
                  <r-timepicker
                    floating-label
                    class="col-50"
                    :label="$t('clientes.cliente_form.hora_cierre')"
                    :form="rform"
                    :readonly="false"
                    name="horaCierre"
                  ></r-timepicker>
                </f7-row>
              </ul>
            </f7-col>
            <f7-col width="100" medium="40">
              <ul>
                <div class="label-group">{{$t('clientes.cliente_form.direccion_inspeccion')}}</div>
                <f7-row>
                  <f7-col width="25">
                    <r-input
                      floating-label
                      :label="$t('clientes.cliente_form.codigo_postal')"
                      :form="rform"
                      type="text"
                      name="direccionInspeccion.cp"
                    ></r-input>
                  </f7-col>
                  <f7-col width="75">
                    <r-input
                      floating-label
                      :label="$t('clientes.cliente_form.direccion')"
                      :form="rform"
                      type="text"
                      name="direccionInspeccion.direccion"
                    ></r-input>
                  </f7-col>
                  <f7-col width="33">
                    <r-input
                      floating-label
                      :label="$t('clientes.cliente_form.poblacion')"
                      :form="rform"
                      type="text"
                      name="direccionInspeccion.poblacion"
                    ></r-input>
                  </f7-col>
                  <f7-col width="33">
                    <r-input
                      floating-label
                      :label="$t('clientes.cliente_form.provincia')"
                      :form="rform"
                      type="text"
                      name="direccionInspeccion.provincia"
                    ></r-input>
                  </f7-col>
                  <f7-col width="33">
                    <r-input
                      floating-label
                      :label="$t('clientes.cliente_form.pais')"
                      :form="rform"
                      type="text"
                      name="direccionInspeccion.pais"
                    ></r-input>
                  </f7-col>
                </f7-row>
                <div class="label-group">{{$t('clientes.cliente_form.direccion_facturacion')}}</div>
                <f7-row>
                  <f7-col width="25">
                    <r-input
                      floating-label
                      :label="$t('clientes.cliente_form.codigo_postal')"
                      :form="rform"
                      type="text"
                      name="direccionFacturacion.cp"
                    ></r-input>
                  </f7-col>
                  <f7-col width="75">
                    <r-input
                      floating-label
                      :label="$t('clientes.cliente_form.direccion')"
                      :form="rform"
                      type="text"
                      name="direccionFacturacion.direccion"
                    ></r-input>
                  </f7-col>
                  <f7-col width="33">
                    <r-input
                      floating-label
                      :label="$t('clientes.cliente_form.poblacion')"
                      :form="rform"
                      type="text"
                      name="direccionFacturacion.poblacion"
                    ></r-input>
                  </f7-col>
                  <f7-col width="33">
                    <r-input
                      floating-label
                      :label="$t('clientes.cliente_form.provincia')"
                      :form="rform"
                      type="text"
                      name="direccionFacturacion.provincia"
                    ></r-input>
                  </f7-col>
                  <f7-col width="33">
                    <r-input
                      floating-label
                      :label="$t('clientes.cliente_form.pais')"
                      :form="rform"
                      type="text"
                      name="direccionFacturacion.pais"
                    ></r-input>
                  </f7-col>
                </f7-row>
              </ul>
            </f7-col>
          </f7-row>
        </f7-card-content>
      </f7-card>
      <f7-card
        class="elevation-3 padding-vertical-half padding-right"
        style="z-index: 1001;"
      >
        <f7-card-content>
          {{$t('clientes.cliente_form.firmas')}}
          <span 
            v-if="!rform.formData.firmas.firmasDisponibles || rform.formData.firmas.firmasDisponibles.length == 0 || rform.formData.firmas.firmasDisponibles.filter(f=>f.nombre).length == 0"
            style="color:red;"
          >
            {{$t('clientes.cliente_form.firmas_textoaviso')}}
          </span>
          <f7-row>
            <f7-list class="col-30 list-form" style="z-index: 1002;">
              <r-autocomplete
                :key="'firmaMecanico'"
                class="padding-vertical"
                style="z-index: 1002;"
                floating-label
                :label="$t('clientes.cliente_form.firmaMecanico')"
                :form="rform"
                :shownFields="['firma']"
                ref="firmaMecanico"
                :name="'firmas.firmaMecanico'"
                labelProp="nombre"
                :readonly="readonly || !rform.formData.firmas.firmasDisponibles || rform.formData.firmas.firmasDisponibles.length == 0 || rform.formData.firmas.firmasDisponibles.filter(f=>f.nombre).length == 0"
                :overrideReadonly="true"
              ></r-autocomplete>
            </f7-list>
            <f7-list class="col-30 list-form" style="z-index: 1002;">
              <r-autocomplete
                :key="'firmaTecnico'"
                class="padding-vertical"
                style="z-index: 1002;"
                floating-label
                :label="$t('clientes.cliente_form.firmaTecnico')"
                :form="rform"
                :shownFields="['firma']"
                ref="firmaTecnico"
                :name="'firmas.firmaTecnico'"
                labelProp="nombre"
                :readonly="readonly || !rform.formData.firmas.firmasDisponibles || rform.formData.firmas.firmasDisponibles.length == 0 || rform.formData.firmas.firmasDisponibles.filter(f=>f.nombre).length == 0"
                :overrideReadonly="true"
              ></r-autocomplete>
            </f7-list>
            <f7-list class="col-30 list-form" style="z-index: 1002;">
              <r-autocomplete
                :key="'firmaMaestroTaller'"
                class="padding-vertical"
                style="z-index: 1002;"
                floating-label
                :label="$t('clientes.cliente_form.firmaMaestroTaller')"
                :form="rform"
                :shownFields="['firma']"
                ref="firmaMaestroTaller"
                :name="'firmas.firmaMaestroTaller'"
                labelProp="nombre"
                :readonly="readonly || !rform.formData.firmas.firmasDisponibles || rform.formData.firmas.firmasDisponibles.length == 0 || rform.formData.firmas.firmasDisponibles.filter(f=>f.nombre).length == 0"
                :overrideReadonly="true"
              ></r-autocomplete>
            </f7-list>
            <f7-list class="col-30 list-form">
              <r-autocomplete
                :key="'firmaResponsableVO'"
                class="padding-vertical"
                style="z-index: 1001;"
                floating-label
                :label="$t('clientes.cliente_form.firmaResponsableVO')"
                :form="rform"
                :shownFields="['firma']"
                ref="firmaResponsableVO"
                :name="'firmas.firmaResponsableVO'"
                labelProp="nombre"
                :readonly="readonly || !rform.formData.firmas.firmasDisponibles || rform.formData.firmas.firmasDisponibles.length == 0 || rform.formData.firmas.firmasDisponibles.filter(f=>f.nombre).length == 0"
                :overrideReadonly="true"
              ></r-autocomplete>
            </f7-list>
            <f7-list class="col-30 list-form">
              <r-autocomplete
                :key="'firmaAsesorServicio'"
                class="padding-vertical"
                style="z-index: 1001;"
                floating-label
                :label="$t('clientes.cliente_form.firmaAsesorServicio')"
                :form="rform"
                :shownFields="['firma']"
                ref="firmaAsesorServicio"
                :name="'firmas.firmaAsesorServicio'"
                labelProp="nombre"
                :readonly="readonly || !rform.formData.firmas.firmasDisponibles || rform.formData.firmas.firmasDisponibles.length == 0 || rform.formData.firmas.firmasDisponibles.filter(f=>f.nombre).length == 0"
                :overrideReadonly="true"
              ></r-autocomplete>
            </f7-list>
            <f7-list class="col-30 list-form">
              <r-autocomplete
                :key="'firmaResponsableVehiculosOcasion'"
                class="padding-vertical"
                style="z-index: 1001;"
                floating-label
                :label="$t('clientes.cliente_form.firmaResponsableVehiculosOcasion')"
                :form="rform"
                :shownFields="['firma']"
                ref="firmaResponsableVehiculosOcasion"
                :name="'firmas.firmaResponsableVehiculosOcasion'"
                labelProp="nombre"
                :readonly="readonly || !rform.formData.firmas.firmasDisponibles || rform.formData.firmas.firmasDisponibles.length == 0 || rform.formData.firmas.firmasDisponibles.filter(f=>f.nombre).length == 0"
                :overrideReadonly="true"
              ></r-autocomplete>
            </f7-list>
          </f7-row>
        </f7-card-content>
      </f7-card>
      <f7-block-title>
        {{$t('clientes.cliente_form.firmasDisponibles')}}
        <f7-link v-if="!rform.readonly" @click="if(!rform.formData.firmas.firmasDisponibles) rform.formData.firmas.firmasDisponibles = []; nuevaFirma();">Nueva Firma</f7-link>
      </f7-block-title>
      <f7-card 
        v-for="(firmaDisponible,index) in rform.formData.firmas.firmasDisponibles" :key="'firmasDisponibles-'+index"
        class="padding-vertical-half padding-right card-inline"
        style="width: auto;"
      >
        <f7-card-content>
          <f7-list class="list-form">
              <r-files 
                class="col-100" 
                style="height: 125px;"
                :maxFiles="1"
                :label="$t('clientes.cliente_form.imagen')" 
                :form="rform" 
                :name="'firmas.firmasDisponibles.'+index+'.firma'" 
                :documentoAdapter="Documento"
              />
              <r-input
                class="col-100"
                floating-label
                :label="$t('clientes.cliente_form.nombre')"
                :form="rform"
                type="text"
                @change="reloadFirmas"
                :name="'firmas.firmasDisponibles.'+index+'.nombre'" 
              ></r-input>
          </f7-list>
        </f7-card-content>
        <f7-link
          v-if="!rform.readonly"
          @click="$delete(rform.formData.firmas.firmasDisponibles,index);reloadFirmas()"
          class="margin-half"
          style="position:absolute;right:0;top:0;"
          icon-f7="trash"
        ></f7-link>
      </f7-card>
      <pre style="display:none;">{{rform.formData}}</pre>

      <f7-block-title v-noroles="['RESPONSABLE','ADMINISTRATIVO']">
        ** {{rform.formData.nombre}} - Contactos del cliente
        <f7-link v-if="!rform.readonly" @click="if(!rform.formData.clienteContactos) rform.formData.clienteContactos = []; rform.formData.clienteContactos.push({});">Nuevo contacto</f7-link>
      </f7-block-title>
      <f7-card 
        v-noroles="['RESPONSABLE','ADMINISTRATIVO']"
        v-for="(clienteContacto,index2) in rform.formData.clienteContactos" :key="'clienteContacto-'+index2"
        class="padding-vertical-half padding-right card-inline"
        style="width: 30%;"
      >
        <f7-card-content  style="width: 95%;">
          <f7-list class="list-form">
            <f7-row class="col-100">
              <div class="col-60">
                <r-autocomplete
                  class="col-100"
                  style="z-index: 1001;"
                  :dbAdapter="ClienteContacto"
                  floating-label
                  :label="$t('perfil.cliente_contacto')"
                  :form="rform"
                  :name="'clienteContactos.' + index2 + '.clienteContacto'"
                  labelProp="nombre"
                  idProp="valor"
                  :source="function(self) {
                    return function(query, render) {
                      var results = [];
                      var clienteContactos = [];
                      if (rform.formData.clienteContactos) {
                        for (var index in rform.formData.clienteContactos) {
                          var cc = rform.formData.clienteContactos[index];
                          if (cc && cc.clienteContacto) {
                            clienteContactos.push(cc.clienteContacto)
                          }
                        }
                      }
                      for (var i = 0; i < self.items.length; i++) {
                        if (
                          ( self.items[i][self.searchProp].toLowerCase().indexOf(query.toLowerCase()) >= 0 ) && 
                          !clienteContactos.includes(self.items[i]['valor'])) {
                            self.items[i]['txtValue'] = self.items[i][self.searchProp];
                            results.push(self.items[i]);
                          }
                      }
                      render(results);
                    };
                  }"
                ></r-autocomplete>
                <r-input
                  class="col-100"
                  floating-label
                  :label="$t('perfil.nombre')"
                  :form="rform"
                  :name="'clienteContactos.' + index2 + '.nombre'"
                ></r-input>
              </div>
              <r-files 
                class="col-33" 
                style="height: 125px;"
                :maxFiles="1"
                :label="$t('perfil.firma')" 
                :form="rform" 
                :name="'clienteContactos.' + index2 + '.firma'" 
              />
            </f7-row>
          </f7-list>
        </f7-card-content>
        <f7-link
          v-if="!rform.readonly"
          @click="$delete(rform.formData.clienteContactos,index2);"
          class="margin-half"
          style="position:absolute;right:0;top:0;"
          icon-f7="trash"
        ></f7-link>
      </f7-card>





      <!-- destinatarios de envío de notificaciones de correo con los cambios de estado de los vehículos en las inspecciones -->
      <f7-block-title v-noroles="['RESPONSABLE']">
        {{$t('clientes.cliente_form.ayuda_destino_aviso')}}
        <f7-link v-if="!rform.readonly" @click="addDestinosAviso()">{{$t('clientes.cliente_form.nuevo_destino_aviso')}}</f7-link>
      </f7-block-title>
      <f7-card v-noroles="['RESPONSABLE']"
        v-for="(destinosAviso,index3) in rform.formData.destinosAvisos" :key="'destinosAvisos-'+index3"
        class="padding-vertical-half padding-right card-inline"
      >
        <f7-card-content style="width: 95%;">
          <f7-list class="list-form">
            <div >
              <f7-row>
                <r-autocomplete
                  v-if="estadosInspeccion"
                  class="col-40"
                  style="z-index: 1001;"
                  floating-label
                  :label="$t('clientes.destino_aviso.estado_inspeccion')"
                  :form="rform"
                  :dbItems="estadosInspeccion"
                  :name="'destinosAvisos.' + index3 + '.estadoInspeccion'"
                  labelProp="nombre"
                  idProp="valor"
                ></r-autocomplete>
                <r-autocomplete
                  v-if="destinosAviso.estadoInspeccion == 'EN_TALLER'"
                  class="col-20"
                  style="z-index: 1001;"
                  floating-label
                  :label="$t('clientes.destino_aviso.departamento')"
                  :form="rform"
                  :dbItems="departamentos"
                  :name="'destinosAvisos.' + index3 + '.departamento'"
                  labelProp="nombre"
                  idProp="valor"
                ></r-autocomplete>
                <!-- <r-autocomplete
                  class="col-33"
                  style="z-index: 1001;"
                  floating-label
                  :label="$t('clientes.destino_aviso.estado_vehiculo')"
                  :form="rform"
                  :dbItems="estadosVehiculo"
                  :name="'destinosAvisos.' + index3 + '.estadoVehiculo'"
                  labelProp="nombre"
                  idProp="valor"
                ></r-autocomplete> -->
                <r-input
                  class="col-40"
                  floating-label
                  :label="$t('clientes.destino_aviso.emails')"
                  :form="rform"
                  :name="'destinosAvisos.' + index3 + '.emails'"
                  :type="'text'"
                ></r-input>
              </f7-row>
            </div>
          </f7-list>
        </f7-card-content>
        <f7-link
          v-if="!rform.readonly"
          @click="$delete(rform.formData.destinosAvisos,index3);"
          class="margin-half"
          style="position:absolute;right:0;top:0;"
          icon-f7="trash"
        ></f7-link>
      </f7-card>

      <!-- Ubicaciones disponibles -->
       <template v-if="rform && rform.formData && rform.formData.tipoCliente && rform.formData.tipoCliente == 'MARCA'">
         <f7-block-title v-noroles="['RESPONSABLE']">
           {{$t('clientes.cliente_form.ayuda_ubicaciones_disponibles')}}
           <f7-link v-if="!rform.readonly" @click="addUbicacion()">{{$t('clientes.cliente_form.nueva_ubicacion')}}</f7-link>
         </f7-block-title>
         <f7-card v-noroles="['RESPONSABLE']"
           v-for="(ubicacion,iubic) in rform.formData.ubicaciones" :key="'ubicaciones-'+iubic"
           class="padding-vertical-half padding-right card-inline"
           :class="ubicacion.tipo"
         >
           <f7-card-content style="width: 95%;">
             <f7-list class="list-form">
               <div >
                 <f7-row>
                   <r-input
                     class="col-40"
                     floating-label
                     :label="$t('clientes.cliente_form.ubicacion.tipo')"
                     :form="rform"
                     :name="'ubicaciones.' + iubic + '.tipo'"
                     :type="'select'"
                     :clearButton="false"
                   >
                     <option selected disabled></option>
                     <option value="UBICACION">{{$t('clientes.cliente_form.ubicacion.ubicacion')}}</option>
                     <option value="TALLER">{{$t('clientes.cliente_form.ubicacion.taller')}}</option>
                     <option value="OTRA">{{$t('clientes.cliente_form.ubicacion.otra')}}</option>
                   </r-input>
                   <r-input
                     class="col-40"
                     floating-label
                     :label="$t('clientes.cliente_form.ubicacion.nombre')"
                     :form="rform"
                     :name="'ubicaciones.' + iubic + '.nombre'"
                     :type="'text'"
                   ></r-input>
                 </f7-row>
               </div>
             </f7-list>
           </f7-card-content>
           <f7-link
             v-if="!rform.readonly"
             @click="$delete(rform.formData.ubicaciones,iubic);"
             class="margin-half"
             style="position:absolute;right:0;top:0;"
             icon-f7="trash"
           ></f7-link>
         </f7-card>
       </template>



      <!-- Marcas asociadas -->
      <f7-block-title v-noroles="['RESPONSABLE','ADMINISTRATIVO']" v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.tipoCliente">
        <div v-if="$refs.rform.formData.tipoCliente == 'MARCA'">
          ** Si no se asocia ninguna marca, el cliente no podrá ver ninguna marca
        </div>
        <div v-else-if="!$refs.rform.formData.idPadre || $refs.rform.formData.idPadre == ''">
          ** Selecciona un Padre para poder añadirle marcas
        </div>
        <div v-else>
          ** Si no se asocia ninguna Marca, este cliente podra ver todas las marcas asociadas a su padre
        </div>
        <f7-card
          class="elevation-3 padding-vertical-half padding-right"
        >
          <f7-card-content>
            <f7-list class="list-form">
                  <r-autocomplete-m2m
                    :dbAdapter="Marca"
                    class="col-100"
                    floating-label
                    :label="$t('clientes.cliente_form.marcas')"
                    :form="rform"
                    name="marcas"
                    labelProp="nombre"
                    type="text"
                    :lineBreak="false"
                    idProp=""
                    :filter="rform && rform.formData && rform.formData.idPadre ? {filter: {clienteId: rform.formData.idPadre}} : {}"
                  ></r-autocomplete-m2m>
            </f7-list>
          </f7-card-content>
        </f7-card>
        <!-- {{$t('clientes.cliente_form.marcas')}}
        <f7-link v-if="!rform.readonly && $refs.rform.formData && $refs.rform.formData.tipoCliente && ($refs.rform.formData.tipoCliente == 'MARCA' || ($refs.rform.formData.idPadre && $refs.rform.formData.idPadre != ''))" @click="rform.formData.marcas.push({})">{{$t('clientes.cliente_form.add')}}</f7-link> -->
      </f7-block-title>

      <!-- Configuraciones -->
      <f7-block-title v-noroles="['RESPONSABLE','ADMINISTRATIVO']" v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.tipoCliente" style="z-index: 30">
        <div v-if="$refs.rform.formData.tipoCliente == 'MARCA'">
          ** Asocie las configuraciones de la marca, después se podrán personalizar por cada Concesionario
        </div>
        <div v-else-if="!$refs.rform.formData.idPadre || $refs.rform.formData.idPadre == ''">
          ** Selecciona un Padre para poder ver y editar sus configuraciones
        </div>
        {{$t('clientes.cliente_form.configuraciones')}}
        <f7-link v-if="!rform.readonly && rform.formData && rform.formData.tipoCliente && rform.formData.tipoCliente == 'MARCA'" @click="rform.formData.configuraciones.push({}); algunCambioEnConf = true;">{{$t('clientes.cliente_form.add')}}</f7-link>
      </f7-block-title>

      <div v-noroles="['RESPONSABLE','ADMINISTRATIVO']" v-if="rform && rform.formData && rform.formData.tipoCliente" style="z-index: 30">
        <f7-card
          class="elevation-3 padding-vertical-half padding-right card-inline"
          v-for="(item,index) in rform.formData.configuraciones"
          :key="'configuracion-'+index"
          :style="'z-index:'+(rform.formData.configuraciones.length - index)"
        >
          <f7-card-content style="width: 95%;">
            <f7-list class="list-form">
              <div>
                <f7-row>
                  <r-autocomplete
                    class="col-25"
                    :dbAdapter="TipoConfiguracion"
                    floating-label
                    :label="$t('clientes.cliente_form.tipo_configuracion')"
                    :form="rform"
                    :name="'configuraciones.' + index + '.tipoConfiguracion'"
                    labelProp="nombre"
                    idProp="valor"
                    @loaded="setExtraObject($event,index,item)"
                    @change="setExtraObject($event,index)"
                    :readonly="rform.formData.tipoCliente != 'MARCA'"
                  ></r-autocomplete>
                  <!-- <r-autocomplete
                    v-if="pintarTipoInspeccion(index)"
                    class="col-25"
                    :dbAdapter="TipoInspeccion"
                    floating-label
                    :label="$t('clientes.cliente_form.tipo_inspeccion')"
                    :form="rform"
                    :name="'configuraciones.' + index + '.tipoInspeccion'"
                    :key="'configuraciones.' + index + '.tipoInspeccion'"
                    labelProp="nombre"
                    idProp="valor"
                    :readonly="rform.formData.tipoCliente != 'MARCA'"
                    @change="algunCambioEnConf = true;"
                  ></r-autocomplete> -->
                  <!-- <div v-else class="col-25"></div> -->
                  <div class="col-25"></div>
                  <r-autocomplete
                    class="col-25"
                    :dbAdapter="AlcanceConfiguracion"
                    floating-label
                    :label="$t('clientes.cliente_form.alcance')"
                    :form="rform"
                    :name="'configuraciones.' + index + '.alcance'"
                    :key="'configuraciones.' + index + '.alcance'"
                    labelProp="nombre"
                    idProp="valor"
                    :readonly="rform.formData.tipoCliente != 'MARCA'"
                    @change="algunCambioEnConf = true;"
                  ></r-autocomplete>
                  <r-input
                    v-if="rform.formData.configuraciones && rform.formData.configuraciones[index] && rform.formData.configuraciones[index].configuracionLinea && rform.formData.configuraciones[index].configuracionLinea.tipoValorDto.nombre == 'COMBO'"
                    class="col-25"
                    floating-label
                    :label="rform.formData.configuraciones[index].configuracionLinea?rform.formData.configuraciones[index].configuracionLinea.tipoValorDto.etiqueta:$t('clientes.cliente_form.valor')"
                    :form="rform"
                    type="select"
                    :name="'configuraciones.' + index + '.valor'"
                    @change="algunCambioEnConf = true;"
                  >
                    <option selected></option>
                    <option v-for="(valor,confIndexValor) in rform.formData.configuraciones[index].configuracionLinea.tipoValorDto.valoresObj"
                      :key="'configuraciones.' + index + '.valor.' + confIndexValor"
                      :value="valor.valor"
                    >{{valor.nombre}}</option>
                  </r-input>
                  <r-input
                    v-else-if="rform.formData.configuraciones && rform.formData.configuraciones[index] && rform.formData.configuraciones[index].configuracionLinea && rform.formData.configuraciones[index].configuracionLinea.tipoValorDto.nombre == 'COMBO_DINAMIC_MULTIPLE'"
                    class="col-25"
                    floating-label
                    :clearButton="false"
                    :label="rform.formData.configuraciones[index].configuracionLinea?rform.formData.configuraciones[index].configuracionLinea.tipoValorDto.etiqueta:$t('clientes.cliente_form.valor')"
                    :form="rform"
                    type="checks"
                    :saveAsString="true"
                    :dbItems="getNameValues(rform.formData.configuraciones[index].configuracionLinea.tipoValorDto.valores)"
                    :name="'configuraciones.' + index + '.valor'"
                    @change="algunCambioEnConf = true;"
                  ></r-input>
                  <!-- <r-input
                    v-else-if="rform.formData.configuraciones && rform.formData.configuraciones[index] && rform.formData.configuraciones[index].configuracionLinea && rform.formData.configuraciones[index].configuracionLinea.tipoValorDto.nombre == 'COMBO_DINAMIC_MULTIPLE'"
                    class="col-25"
                    floating-label
                    :clearButton="false"
                    :label="rform.formData.configuraciones[index].configuracionLinea?rform.formData.configuraciones[index].configuracionLinea.tipoValorDto.etiqueta:$t('clientes.cliente_form.valor')"
                    :form="rform"
                    type="checks"
                    :name="'configuraciones.' + index + '.valor'"
                    @change="algunCambioEnConf = true;"
                  >
                    <option selected></option>
                    <option v-for="(valor,confIndexValor) in JSON.parse(rform.formData.configuraciones[index].configuracionLinea.tipoValorDto.valores)"
                      :key="'configuraciones.' + index + '.valor.' + confIndexValor"
                      :value="valor.valor"
                    >{{valor.nombre}}</option>
                  </r-input> -->
                  <r-autocomplete
                    v-else-if="esAutocomplete(index)"
                    class="col-25"
                    floating-label
                    :dbAdapter="Formato"
                    :label="rform.formData.configuraciones[index].configuracionLinea?rform.formData.configuraciones[index].configuracionLinea.tipoValorDto.etiqueta:$t('clientes.cliente_form.valor')"
                    :form="rform"
                    :name="'configuraciones.' + index + '.valor'"
                    :labelProp="getValorJsonObject(rform.formData.configuraciones[index].configuracionLinea.tipoValorDto.valores, 'labelProp')"
                    :idProp="getValorJsonObject(rform.formData.configuraciones[index].configuracionLinea.tipoValorDto.valores, 'idProp')"
                    @change="algunCambioEnConf = true;"
                  >
                  </r-autocomplete>
                  <r-input
                    v-else
                    class="col-25"
                    floating-label
                    :label="rform.formData.configuraciones[index].configuracionLinea?rform.formData.configuraciones[index].configuracionLinea.tipoValorDto.etiqueta:$t('clientes.cliente_form.valor')"
                    :form="rform"
                    :name="'configuraciones.' + index + '.valor'"
                    @change="algunCambioEnConf = true;"
                  ></r-input>
                </f7-row>
              </div>
            </f7-list>
          </f7-card-content>
          <f7-link
            v-if="!rform.readonly && rform.formData && rform.formData.tipoCliente && rform.formData.tipoCliente == 'MARCA'"
            @click="$delete(rform.formData.configuraciones,index); algunCambioEnConf = true;"
            class="margin-half"
            style="position:absolute;right:0;top:0;"
            icon-f7="trash"
          ></f7-link>
        </f7-card>
      </div>
      <!-- Configuraciones -->
      <f7-block-title v-noroles="['RESPONSABLE']" v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.tipoCliente">
        {{$t('clientes.cliente_form.configuraciones')}}
        <f7-link style="z-index: 0;" v-if="!rform.readonly && rform.formData && rform.formData.tipoCliente && rform.formData.tipoCliente == 'MARCA'" @click="rform.formData.configuraciones.push({}); algunCambioEnConf = true;">{{$t('clientes.cliente_form.add')}}</f7-link>
      </f7-block-title>
    </r-form>
  </f7-page>
</template>
<style scoped>
  .label-group {
    margin-top: 12px;
    margin-left: 20px;
    font-weight: bold;
  }
  .label-group-inspeccion {
    margin-top: 30px;
  }
  label.btn {
    padding: 1px;
    cursor: pointer;
    border: 1px solid;
  }

  .input-focused {
    border-color: #007aff;
  }

  .card-inline {
    display: inline-flex;
    margin: 0 10px 10px 10px;
    width: 47%;
  }
</style>
<style>
  .autocomplete-dropdown {
    z-index: 3000;
  }
</style>
<script>
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import rFiles from "./../../components/rFiles.vue";
import rAutocomplete from "./../../components/rAutocomplete.vue";
import rAutocompleteM2m from "./../../components/rAutocompleteM2m.vue";
import rTimepicker from "./../../components/rTimepicker.vue";
import Cliente from "./../../js/db/Cliente.js";
import TipoConfiguracion from "./../../js/db/TipoConfiguracion.js";
import TipoInspeccion from "./../../js/db/TipoInspeccion.js";
import AlcanceConfiguracion from "./../../js/db/AlcanceConfiguracion.js";
import TipoProcedimiento from "./../../js/db/TipoProcedimiento.js";
import ClienteContacto from "./../../js/db/ClienteContacto.js";
import Documento from "./../../js/db/Documento.js";
import Formato from "./../../js/db/Formato.js";
import Marca from "./../../js/db/Marca.js";
import Firma from "./../../js/db/Firma.js";
import Combos from "./../../js/db/Combos.js";

export default {
  components: {
    rForm,
    rInput,
    rTimepicker,
    rFiles,
    rAutocomplete,
    rAutocompleteM2m
  },
  data: function() {
    var self = this;
    return {
      Cliente,
      ClienteContacto,
      Documento,
      Formato,
      Marca,
      Firma,
      TipoConfiguracion,
      TipoInspeccion,
      AlcanceConfiguracion,
      TipoProcedimiento,
      algunCambioEnConf: false,
      readonly: !this.editable,
      newImagenSelected : false,
      Combos,
      estadosInspeccion: [],
      departamentos: [],
      tiposConfiguracion: [],
    };
  },
  props: {
    id: {
      type: String
    },
    editable: {
      type: Boolean,
      default: true
    },
    vo: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  beforeDestroy() {},
  methods: {
    changeTipoCliente: function(e) {
      var self = this;
      if(!self.$refs.rform.formData.id && typeof e == "string") {
        if (e == "MARCA") {
          self.$set(self.$refs.rform.formData, 'configuraciones', JSON.parse('[{"tipoConfiguracion":"PROCEDIMIENTO","configuracionLinea":{"nombre":"Procedimiento","conTipoInspeccion":false,"tipoValor":"com.digitaltpm.givo.api.cliente.enums.TipoProcedimientoEnum","tipoValorDto":{"tipoValor":"com.digitaltpm.givo.api.cliente.enums.TipoProcedimientoEnum","nombre":"COMBO","etiqueta":"Procedimiento","valores":"[{\\"nombre\\":\\"Precertificación\\",\\"valor\\":\\"PROCEDIMIENTO_PRECERTIFICACION\\"},{\\"nombre\\":\\"1ª y 2ª Certificación\\",\\"valor\\":\\"PROCEDIMIENTO_1\\"},{\\"nombre\\":\\"1ª Certificación y Facturas.\\",\\"valor\\":\\"PROCEDIMIENTO_2\\"},{\\"nombre\\":\\"Desinfección.\\",\\"valor\\":\\"PROCEDIMIENTO_DESINFECCION\\"}]","valoresObj":[{"nombre":"Precertificación","valor":"PROCEDIMIENTO_PRECERTIFICACION"},{"nombre":"1ª y 2ª Certificación","valor":"PROCEDIMIENTO_1"},{"nombre":"1ª Certificación y Facturas.","valor":"PROCEDIMIENTO_2"},{"nombre":"Desinfección.","valor":"PROCEDIMIENTO_DESINFECCION"}]}},"alcance":"TODOS","valor":"PROCEDIMIENTO_PRECERTIFICACION"},{"tipoConfiguracion":"FORMATO_PEDIDO","configuracionLinea":{"nombre":"Formato del pedido","conTipoInspeccion":true,"tipoValor":"java.lang.String","tipoValorDto":{"tipoValor":"java.lang.String","nombre":"TEXTO","etiqueta":"Formato"}},"tipoInspeccion":"PRECERTIFICACION","alcance":"TODOS","valor":"61116384e5594303ca11e097"},{"tipoConfiguracion":"PRECIO","configuracionLinea":{"nombre":"Precio Defecto","conTipoInspeccion":true,"tipoValor":"java.math.BigDecimal","tipoValorDto":{"tipoValor":"java.math.BigDecimal","nombre":"NUMERO","etiqueta":"Precio"}},"tipoInspeccion":"PRECERTIFICACION","alcance":"TODOS","valor":"45"},{"tipoConfiguracion":"TIEMPO","configuracionLinea":{"nombre":"Tiempo Defecto","conTipoInspeccion":true,"tipoValor":"java.math.BigDecimal","tipoValorDto":{"tipoValor":"java.math.BigDecimal","nombre":"NUMERO","etiqueta":"Tiempo"}},"tipoInspeccion":"PRECERTIFICACION","alcance":"TODOS","valor":"100"}]'));
        } else {
          self.$set(self.$refs.rform.formData, 'configuraciones', []);
        }
      }
      self.$set(self.$refs.rform.formData, 'marcas', []); 
      self.$set(self.$refs.rform.formData, 'idPadre', undefined)
    },
    setExtraObject: function(e,index,item) {
      var self = this;
      if(e.extraObject) {
        self.algunCambioEnConf = true;
        if(e.extraObject.tipoValorDto && e.extraObject.tipoValorDto.valores) {
          e.extraObject.tipoValorDto.valoresObj = JSON.parse(e.extraObject.tipoValorDto.valores);
        }
        self.$refs.rform.formData.configuraciones[index].configuracionLinea = e.extraObject;
      } else if("change" === e.type) {
        console.log(e.type);
      } else {
        if(e.find(opt => opt.valor === item.tipoConfiguracion)) e.find(opt => opt.valor === item.tipoConfiguracion).extraObject
        var tipoConfiguracion = e.find(opt => opt.valor === item.tipoConfiguracion);
        if(tipoConfiguracion && tipoConfiguracion.extraObject && tipoConfiguracion.extraObject.tipoValorDto && tipoConfiguracion.extraObject.tipoValorDto.valores) {
          try {
            tipoConfiguracion.extraObject.tipoValorDto.valoresObj = JSON.parse(tipoConfiguracion.extraObject.tipoValorDto.valores);
          } catch (error) {
            console.log("JSON-ERROR: " + tipoConfiguracion.extraObject.tipoValorDto.valores)
          }
        }
        if(item && tipoConfiguracion && tipoConfiguracion.extraObject) {
          item.configuracionLinea = tipoConfiguracion.extraObject;
        }
        // No sé que hace pero arregla mi problema ----------------------
        self.$refs.rform.formData.cambiarConfiguracionesEnHijos = true;
        self.$refs.rform.formData.cambiarConfiguracionesEnHijos = false;
        // --------------------------------------------------------------

      }
    },
    reloadFirmas: function(){
      var self = this,
        firmaMecanico = self.$refs.firmaMecanico,
        firmaTecnico = self.$refs.firmaTecnico,
        firmaMaestroTaller = self.$refs.firmaMaestroTaller,
        firmaResponsableVO = self.$refs.firmaResponsableVO,
        firmaAsesorServicio = self.$refs.firmaAsesorServicio,
        firmaResponsableVehiculosOcasion = self.$refs.firmaResponsableVehiculosOcasion,
        firmasDefecto = [firmaMecanico, firmaTecnico, firmaMaestroTaller, firmaResponsableVO, firmaAsesorServicio,firmaResponsableVehiculosOcasion];
      firmasDefecto.forEach(firmaRef => {
        if(!firmaRef) return;
        firmaRef.reload(self.$refs.rform.formData.firmas.firmasDisponibles);
        if(firmaRef.selected && firmaRef.selected.id && !firmaRef.items.some(item => item.id == firmaRef.selected.id)){
          firmaRef.setValue(null);
        }
      });
    },
    nuevaFirma: function(){
      var self = this,
        rform = self.$refs.rform,
        id = new Date().getTime().toString(36) + Math.random().toString(36).slice(2);
      rform.formData.firmas.firmasDisponibles.push({id:id});
    },
    changePadre: function(e) {
      var self = this;
      var app = self.$f7;
      if (!self.id && self.$refs.rform.formData.idPadre && self.$refs.rform.formData.tipoCliente != 'MARCA') {
        Cliente.get({itemId: self.$refs.rform.formData.idPadre,data: {}},false).then(function(res) {
          self.$set(self.$refs.rform.formData, 'servidor', res.servidor); 
          self.$set(self.$refs.rform.formData, 'conectarConSIMECAR', res.conectarConSIMECAR); 
        }).catch(function(error) {
          if (error.message) {
            app.dialog.alert(error.message);
          } else {
            app.dialog.alert(error);
          }
        })
        Cliente.getConfiguraciones({data: {idCliente: self.$refs.rform.formData.idPadre}}).then(function(res) {
          self.$set(self.$refs.rform.formData, 'configuraciones', res); 
        }).catch(function(error) {
          if (error.message) {
            app.dialog.alert(error.message);
          } else {
            app.dialog.alert(error);
          }
        })

      }
    },
    loadItem: function(res) {
      var self = this;
      let iteraciones = 0;
      while(!self.departamentos && self.departamentos.length && iteraciones < 10) {
        setTimeout('', 1000);
        console.log("Esperando departamentos " + iteraciones++);
      }
      if (!res.firmas || !res.firmas.firmasDisponibles || res.firmas.firmasDisponibles == null) {
        self.$set(self.$refs.rform.formData, 'firmas', {});
        self.$set(self.$refs.rform.formData.firmas, 'firmasDisponibles', []);
      }
      self.reloadFirmas();
      if (!res.marcas || res.marcas == null) {
        self.$set(self.$refs.rform.formData, 'marcas', []);
      }
      if (!res.configuraciones || res.configuraciones == null) {
        self.$set(self.$refs.rform.formData, 'configuraciones', []);
      }
      // self.tiposConfiguracion.getList().then(res => {
      //   self.tiposConfiguracion = res.list;
      //   // Aplicamos a cada configuración los datos de su tipo en el campo configuracionLinea
      //   if (self.$refs.rform.formData.configuraciones) {
      //     self.$refs.rform.formData.configuraciones.forEach((configuracion, index) => {
      //       let tipoConfiguracion = self.tiposConfiguracion.find(tipo => tipo.nombre == configuracion.tipoConfiguracion);
      //       if (tipoConfiguracion) {
      //         self.$set(configuracion,'configuracionLinea',tipoConfiguracion);
      //       }
      //     });
      //   }
      // }).catch(error => { if (error.message) {app.dialog.alert(error.message);} else {app.dialog.alert(error);} });
    },
    beforeSave: function(data, resolve, reject) {
      var self = this;
      var app = self.$f7;
      var formData = data;

      formData.imagen = Array.isArray(formData.imagen) ? formData.imagen[0] : formData.imagen;
      if (self.algunCambioEnConf && formData.tipoCliente == 'MARCA') {
        app.preloader.hide();
        app.dialog.confirm(
          "¿Desea efectuar estos cambios en los concesionarios asociados a la Marca?" ,
          "Cambios en Concesionarios",
          function() {
            formData.cambiarConfiguracionesEnHijos = true;
            resolve(formData);
          },
          function() {
            formData.cambiarConfiguracionesEnHijos = false;
            resolve(formData);
          }
        );
      } else {
        formData.cambiarConfiguracionesEnHijos = false;
        resolve(formData);
      }

      // Revisar los contactos del cliente para ver si tienen firma de tipo list
      if (formData.clienteContactos) {
        formData.clienteContactos.forEach(function(contacto) {
          if (contacto.firma instanceof Array && contacto.firma.length > 0) {
            contacto.firma = contacto.firma[0];
          }
        });
      } else {
        formData.cambiarContactosEnHijos = false;
        resolve(formData);
      }

      if (formData.firmas && formData.firmas.firmasDisponibles){
        formData.firmas.firmasDisponibles.forEach(function(firma) {
          if (firma.firma instanceof Array && firma.firma.length > 0) {
            firma.firma = firma.firma[0];
          }
        });
      }
    },
    onSave: function(res) {
      var self = this;
      var app = self.$f7;
      var router = self.$f7router;
      self.$refs.rform.formData = res;
      self.readonly = true;
      app.toast
        .create({
          text: self.$t("clientes.cliente_form.cliente_guardado"),
          position: "center",
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();
    },
    addDestinosAviso: function() {
      var self = this;
      let rform = self.$refs.rform;
      if(!rform.formData.destinosAvisos) {
        self.$set(rform.formData, 'destinosAvisos', []);
      }
      rform.formData.destinosAvisos.push({});
    },
    addUbicacion: function() {
      var self = this;
      let rform = self.$refs.rform;
      if(!rform.formData.ubicaciones) {
        self.$set(rform.formData, 'ubicaciones', []);
      }
      rform.formData.ubicaciones.push({});
    },
    getValorJsonObject: function(jsonStr, nombreCampo) {
      var self = this;
      let rform = self.$refs.rform;
      try {
        let json = JSON.parse(jsonStr);
        return json[nombreCampo];
      } catch (error) {
        return "";
      }
    },
    esAutocomplete: function(index) {
      var self = this;
      let rform = self.$refs.rform;
      if(
          rform.formData.configuraciones 
          && rform.formData.configuraciones[index] 
          && rform.formData.configuraciones[index].configuracionLinea 
          && rform.formData.configuraciones[index].configuracionLinea.tipoValorDto.nombre == 'AUTOCOMPLETE'
      ) {
        return true;
      }
      return false;
    },
    pintarTipoInspeccion: function(index) {
      var self = this;
      let rform = self.$refs.rform;
      return rform.formData.configuraciones && rform.formData.configuraciones[index] && rform.formData.configuraciones[index].configuracionLinea && rform.formData.configuraciones[index].configuracionLinea.conTipoInspeccion === true;
    },
    getNameValues: function(valores) {
      var self = this;
      let rform = self.$refs.rform;
      let result = [];
      if(valores) {
        JSON.parse(valores).forEach((valor, index) => {
          result.push({name: valor.nombre, value: valor.valor});
        });
      }
      return result;
    }

  },
  created: function() {
    var self = this;
    var app = self.$f7;
    var router = self.$f7router;

    // Combos.getComboById("estadosVehiculo").then(res => {
    //   self.estadosVehiculo = res.list;
    // }).catch(error => {
    //   if (error.message) {
    //     app.dialog.alert(error.message);
    //   } else {
    //     app.dialog.alert(error);
    //   }
    // });
    Combos.getComboById("estadosInspeccion").then(res => {
      self.estadosInspeccion = res.list;
      
      Combos.getComboById("departamentos").then(res => {
        self.departamentos = res.list;
        if(!self.$refs.rform.formData.destinosAvisos || self.$refs.rform.formData.destinosAvisos.length == 0) {
          self.$set(self.$refs.rform.formData, 'destinosAvisos', []);
          self.estadosInspeccion.forEach((item,index) => {
            // Si item.valor es EN_TALLER, le metemos el departamento y desdoblamos en 3
            if(item.valor == "EN_TALLER") {
              self.departamentos.forEach((departamento, index2) => {
                self.$refs.rform.formData.destinosAvisos.push({estadoInspeccion: item.valor, departamento: departamento.valor});
              });
            } else {
              self.$refs.rform.formData.destinosAvisos.push({estadoInspeccion: item.valor});
            }
          });
        }
        let destinosAvisos = self.$refs.rform.formData.destinosAvisos;
        console.log( JSON.stringify(self.$refs.rform.formData.destinosAvisos) );
        self.$set(self.$refs.rform.formData, 'destinosAvisos', []);
        self.$set(self.$refs.rform.formData, 'destinosAvisos', destinosAvisos);
      }).catch(error => {
        if (error.message) {
          app.dialog.alert(error.message);
        } else {
          app.dialog.alert(error);
        }
      });
    }).catch(error => {
      if (error.message) {
        app.dialog.alert(error.message);
      } else {
        app.dialog.alert(error);
      }
    });
    Combos.getComboById("departamentos").then(res => {
      self.departamentos = res.list;
    }).catch(error => {
      if (error.message) {
        app.dialog.alert(error.message);
      } else {
        app.dialog.alert(error);
      }
    });
  },
  mounted: function() {
    var self = this;
    var $ = self.$$;
    var $el = $(self.$el);
    var app = self.$f7;
    // Miramos si el cliente tiene configuraciones, si no tiene ese campo, se lo creamos como array vacío
    if(!self.$refs.rform.formData.configuraciones) {
      self.$set(self.$refs.rform.formData, 'configuraciones', []);
    }
    // Si no tenemos lista de contactos del cliente, la inicializamos vacía.
    if(!self.$refs.rform.formData.clienteContactos) {
      self.$set(self.$refs.rform.formData, 'clienteContactos', []);
    }
  }
};
</script>